import { authApi, AuthApi } from './auth';

export { authApi, AuthApi };



// WEBPACK FOOTER //
// ./src/api/auth/index.ts